export const DEFAULT_LOGO_URL =
    'https://marketingcdn.giftcardgranny.com/Homepage/images/gcg-logo.svg'

export const VALENTINES_LOGO_URL =
    'https://res.cloudinary.com/gift-card-granny/image/upload/f_webp/v1768339661/GCG/assets/logos/Brand_GiftYa_Color_Full_Division_Main_Icon_No_Orientation_Horizontal_Smiling_Wolf_No_size_Default_twga0m'
